import type { GlobalFilter, FilterType, FilterKindEnum } from '@hotjar/global-filters';

export const getAppliedFiltersList = (filterList: FilterType[]): FilterKindEnum[] => {
  return filterList.map((item: FilterType) => item.kind);
};

export const mergeSessionFilters = (
  sessionFiltersInUiFormat: GlobalFilter,
  dateRangeInUiFormat: GlobalFilter,
): GlobalFilter => {
  const merged: GlobalFilter = {
    dateRange: dateRangeInUiFormat.dateRange,
    filterList: sessionFiltersInUiFormat.filterList,
  };
  return merged;
};
